import { PipelinesLoadingFallback } from '@/features/pipelines/components/PipelinesLoadingFallback';
import { PipelinesTablePanel } from '@/features/pipelines/components/PipelinesTablePanel';
import { usePipelinesPageViewModel } from '@/features/pipelines/hooks';
import { StackedMetricsStatusChartSection } from '@/features/shared/components/chartPanels/StackedMetricsStatusChartSection';
import { DelayedSkeletonGate } from '@/ui/composites';
import { ListPageTemplate } from '@/ui/composites/scaffolds';
import { Stack } from '@/ui/layout/Stack';
import { Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

export const PipelinesPage = (): ReactElement => {
  const { metricSectionProps, showPageSkeleton, tablePanelProps } = usePipelinesPageViewModel();

  return (
    <DelayedSkeletonGate show={showPageSkeleton} fallback={<PipelinesLoadingFallback />}>
      <ListPageTemplate
        title={
          <Text role="sectionTitle" component="h1">
            Pipelines
          </Text>
        }
        content={
          <Stack gap="2xl">
            <StackedMetricsStatusChartSection {...metricSectionProps} />
            <PipelinesTablePanel {...tablePanelProps} />
          </Stack>
        }
      />
    </DelayedSkeletonGate>
  );
};
